import { render, staticRenderFns } from "./ProjectionTable.vue?vue&type=template&id=247837a0&scoped=true"
import script from "./ProjectionTable.vue?vue&type=script&lang=js"
export * from "./ProjectionTable.vue?vue&type=script&lang=js"
import style0 from "./ProjectionTable.vue?vue&type=style&index=0&id=247837a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247837a0",
  null
  
)

export default component.exports